import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { SubdominiosService } from 'src/app/core/services/dominios.service';
import { TransactionsService } from 'src/app/core/services/transactions.service';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-confirmation-payment',
  templateUrl: './confirmation-payment.component.html',
  styleUrls: ['./confirmation-payment.component.scss'],
})
export class ConfirmationPaymentComponent implements OnInit {
  private idTran: any;
  public estado_transaccion = null;
  public valor_transaccion = null;
  public usuario = null;

  constructor(
    private router: Router,
    private svUtils: UtilsService,
    private aRoute: ActivatedRoute,
    private svTransaction: TransactionsService,
    private svDomain: SubdominiosService,
    private svUsuario: UsuarioService
  ) {}

  ngOnInit(): void {
    this.getLoggedUser();
    this.getPayment();
  }

  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser();
    if (this.usuario.id_empresa_perteneciente) {
      this.getCompany(this.usuario.id_empresa_perteneciente);
    }
  }
  getCompany(id_empresa_usuario) {
    this.svUsuario.getCompany(id_empresa_usuario).subscribe((resp) => {
      if (resp['status'] === 'success') {
        resp = resp['body']['data'][0];
        localStorage.setItem('empresa', JSON.stringify(resp));
      }
    });
  }
  finish() {
    this.router.navigate(['/']);
  }
  parseAmount(value: number): string {
    if (value) {
      return this.svUtils.parseNumberToPesos(value);
    } else {
      return '$ 0';
    }
  }
  getPayment() {
    this.aRoute.queryParams.pipe(take(1)).subscribe((params) => {
      this.idTran = params['transId'];
      this.svTransaction.getPaymentResult(this.idTran).subscribe((result) => {
        if (result['rs_resultado']) {
          result = result['rs_resultado'][0];
          let data_trans = {
            id_usuario: this.usuario['id_usuario'],
            plan_comercial: localStorage.getItem('plan_comercial'),
            cantidad_de_asistentes: localStorage.getItem(
              'cantidad_de_asistentes'
            ),
            id_parametro_tipo_transaccion: null,
            id_transaccion_flexipay: result['id_transacion_comercio'],
            valor_transaccion: result['valor_total_comercio'],
            tipo_de_evento: localStorage.getItem('tipo_de_evento'),
          };

          this.estado_transaccion = result['id_estado_transaccion_comercio'];
          this.valor_transaccion = this.parseAmount(
            result['valor_total_comercio']
          );
          if (this.estado_transaccion == 5) {
            let data_verify = {
              id_transaccion_flexipay: result['id_transacion_comercio'],
            };

            this.svTransaction
              .verifyTransaction(data_verify)
              .subscribe((resp_verify) => {
                if (resp_verify['body']) {
                  if (resp_verify['body']['status'] === 'success') {
                    Swal.fire(
                      'Pago no válido',
                      'La transacción ya ha sido registrada en el sistema!',
                      'warning'
                    );
                  } else {
                    localStorage.setItem('estado_transaccion', 'success');

                    this.svTransaction
                      .addTransaction(data_trans)
                      .subscribe((resp_add) => {
                        if (resp_add['status'] == 'success') {
                          let empresa = JSON.parse(
                            localStorage.getItem('empresa')
                          );
                          if (
                            empresa['id_subdominio'] &&
                            empresa['id_usuario']
                          ) {
                            let data_activate = {
                              id_subdominio: empresa['id_subdominio'],
                              id_usuario_subdominio: empresa['id_usuario'],
                              cuenta_activa_subdominio: 'Si',
                            };
                            this.svDomain
                              .activateDomain(data_activate)
                              .subscribe((resp_activate) => {
                                // console.log(resp_activate)
                              });
                          }
                        }
                      });
                  }
                }
              });
          }
        }
      });
    });
  }
}
